// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesTypeFirst_feature__2ZNbE","title":"FeaturesTypeFirst_title__1_FK8","description":"FeaturesTypeFirst_description__15pRI"};